// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/06118b8750884a44aacf.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"68f56541ba29805e994b","194":"bf11a9b44fd43267f82f","195":"dbb94dc19bf8968683e9"}[chunkId] + ".chunk.js";
};